require("jquery.maskedinput/src/jquery.maskedinput.js");
require("jquery-countto");
require("readmore-js");

export default () => {
  if ($(window).width() > 1200) {
    $('.animation-element').viewportChecker({
      classToAdd: 'visible',
      // repeat: true
    });
  }
  if ($(window).width() < 1200) {
    if ($('.gallery-one__title').length) {
      $('.gallery-one__title').insertBefore($('.gallery-one__sliders'))
      $('.gallery-one__row').insertAfter($('.gallery-one__title'))
    }
  }

  $('.js-worldwide').on('click', function () {
    $(".menu2--worldwide").addClass('active');
    if ($(window).width() < 1200) {
      $(".menu2--worldwide .menu2__holder").addClass("active");
      $(".header__mobile-box").removeClass("active");
      setTimeout(() => {
        $(".header__mobile").removeClass("active");
      }, 300);
    }
  });
  $(".js-worldwide-close").on("click", function () {
    if ($(window).width() < 1200) {
      $(".menu2__holder").removeClass("active");
      setTimeout(() => {
        $(".menu2").removeClass("active");
      }, 300);
    } else {
      $(".menu2--worldwide").removeClass("active");
    }
  });
  $(".js-main-overlay").on("click", function () {
    if ($(window).width() < 1200) {
      $(".menu2__holder").removeClass("active");
      setTimeout(() => {
        $(".menu2").removeClass("active");
      }, 300);
    }
  });

  $(".js-callBack").on('click', function () {
    $(".popup--callBack").addClass('active');
  });

  // $(".js-questionnaire").on('click', function () {
  //   $(".popup--questionnaire").addClass('active');
  // });

  const lang = $('html').attr('lang');
  var lang1;
  if (lang === 'ua') {
    var lang1 = "Читати повністю";
    var lang2 = "Згорнути";
  }
  if (lang === 'ru') {
    var lang1 = 'Читать полность';
    var lang2 = "Свернуть";
  }
  if (lang === 'en') {
    var lang1 = "Read more";
    var lang2 = "Close";
  }

  $(".product-card__cell-text").each(function (index, element) {
    $(element).readmore({
      moreLink: `<a href="#" class="product-card__open-btn">${lang1}</a>`,
      lessLink: `<a href="#" class="product-card__open-btn open">${lang2}</a>`
    });
  });

  $(document).on("click touchend", event => {
    if ($(event.target).closest(".jobs__regions-drop").length) return;
    $(".jobs__regions").each(function (index, element) {
      if ($(element).hasClass('active')) {
        $(element).removeClass("active");
      }
    });
    event.stopPropagation();
  });
  $('.jobs__regions-title--drop').on('click', function (event) {
    if (!$(this).parent('.jobs__regions').hasClass('active')) {
      $(".jobs__regions").removeClass("active");
    }
    $(this).parent('.jobs__regions').addClass('active');
    event.stopPropagation();
  });

  if ($('.counter').length) {
    $('.counter').viewportChecker({
      offset: 250,
      callbackFunction: function (elem, action) {
        $(".js-counter").countTo();
      }
    });
  }

  $(".js-close-popup").on('click', function () {
    $('.popup:not(.popup--warning)').removeClass('active');
  });

  $('.form__file').on('change', function () {
    if ($(this).val().lastIndexOf('\\')) {
      var n = $(this).val().lastIndexOf('\\') + 1;
    } else {
      var n = $(this).val().lastIndexOf('/') + 1;
    }
    var fileName = $(this).val().slice(n);
    $(".form__name-file").text(fileName);
  });

  $(".form__textarea-btn").on('click', function () {
    $(this).toggleClass("active");
    $(this).next('.your-message').slideToggle();
  });

  $('.js-additional-field').on("click", function (event) {
    if ($(this).hasClass('js-additional-field--add') && $(this).prop('checked')) {
      $(this).parents('.js-additional-field-parent').addClass('active');
    } else {
      $(this).parents('.js-additional-field-parent').removeClass('active');
    }
    event.stopPropagation();
  });

  $(".js-active-input").each(function (index, element) {
    if ($(element).val() !== "") {
      $(element).parents(".js-parent-input").addClass('active');
    }
  });
  $(document).on('focus load', '.js-active-input', function () {
    $(this).parents(".js-parent-input").addClass('active');
  });
  $(document).on('blur', '.js-active-input', function () {
    if ($(this).val() == '') {
      $(this).parents(".js-parent-input").removeClass('active');
    }
  });

  $(".js-scroll-btn").on("click", function ancordsLinks(e) {
    const id = $(this).attr("href");
    e.preventDefault();
    const top = $(id).offset().top - 111;
    $("body,html").animate({ scrollTop: top }, 1000);
  });

  if ($(window).width() < 1200) {
    $(".js-mobile-filter").on('click', function () {
      $(".catalog__filter").addClass("active");
      $(".catalog__filter-holder").addClass("active");
    });
    $(".js-close-filter").on("click", function () {
      $(".catalog__filter-holder").removeClass("active");
      setTimeout(() => {
        $(".catalog__filter").removeClass("active");
      }, 300);
    });

    $(".js-mobile-btn").on('click', function () {
      $(".header__mobile").addClass("active");
      $(".header__mobile-box").addClass("active");
    });
    $(".js-close-mobile").on("click", function () {
      $(".header__mobile-box").removeClass("active");
      setTimeout(() => {
        $(".header__mobile").removeClass("active");
      }, 300);
    });
  }
  if ($(window).width() < 767) {
    $(".on-map").on('click', function () {
      $("body,html").animate({ scrollTop: 0 }, 300);
    });
  }

  $(".main-slider__item-imgPrev").each(function (index, element) {
    const nextItem = $(element).parents(".slick-slide").next('.slick-slide').find('.main-slider__item-img').attr('style');
    $(element).attr("style", nextItem);
  });
  const imgPrev = $(".main-slider__item-imgPrev").parents(".slick-slide");
  const imgPrevFirst = $(imgPrev[imgPrev.length - 1]).find('.main-slider__item-img').attr('style');
  const imgPrevLAst = imgPrev[0];
  $(imgPrevLAst).find(".main-slider__item-imgPrev").attr("style", imgPrevFirst);


  $(".js-products").on('click', function () {
    $(".menu, .menu__holder").addClass('active');
  });
  $(".js-close-menu").on("click", function () {
    $(".menu__holder").removeClass("active");
    setTimeout(() => {
      $(".menu").removeClass("active");
    }, 300);
  });

  $(".header__search-btn").on("click", function (event) {
    $(".header__form").toggleClass("active");
    event.stopPropagation();
  });
  $(document).on("click touchend", (event) => {
    if ($(window).width() < 1200) {
      if ($(event.target).closest(".header__form-btn, .header__form-input, .header__search-btn").length) return;
    } else {
      if ($(event.target).closest(".header__form-btn, .header__form-input").length) return;
    }
    $(".header__form").removeClass('active');
    event.stopPropagation();
  });
  $(".header__lang-current").on("click", function (event) {
    $(".header__lang").toggleClass("active");
    event.stopPropagation();
  });
  $(document).on("click touchend", (event) => {
    if ($(event.target).closest(".header__lang").length) return;
    $(".header__lang").removeClass('active');
    event.stopPropagation();
  });

  jQuery(function ($) {
    $("input[type=tel]").mask("+38(099)99-99-999");
    if ($(window).width() < 767) {
      $("input[type=tel]").mask("+380999999999");
    } else {
      $("input[type=tel]").mask("+38(099)99-99-999");
    }
  });
}


// WEBPACK FOOTER //
// app/scripts/components/custom.js